// Screens
import Main from './screens/Main'

import './scss/style.scss'

// React-redux
import { Provider } from 'react-redux'
import store from './redux/store'

function App() {
  return (
    <Provider store={store}>
      <Main />
    </Provider>
  );
}

export default App;
